"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tap = tap;

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Subscriber2 = require("../Subscriber");

/* tslint:enable:max-line-length */

/**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */
function tap(nextOrObserver, error, complete) {
  return function tapOperatorFunction(source) {
    return source.lift(new DoOperator(nextOrObserver, error, complete));
  };
}

var DoOperator =
/*#__PURE__*/
function () {
  function DoOperator(nextOrObserver, error, complete) {
    (0, _classCallCheck2.default)(this, DoOperator);
    this.nextOrObserver = nextOrObserver;
    this.error = error;
    this.complete = complete;
  }

  (0, _createClass2.default)(DoOperator, [{
    key: "call",
    value: function call(subscriber, source) {
      return source.subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    }
  }]);
  return DoOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */


var DoSubscriber =
/*#__PURE__*/
function (_Subscriber) {
  (0, _inherits2.default)(DoSubscriber, _Subscriber);

  function DoSubscriber(destination, nextOrObserver, error, complete) {
    var _this;

    (0, _classCallCheck2.default)(this, DoSubscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DoSubscriber).call(this, destination));
    var safeSubscriber = new _Subscriber2.Subscriber(nextOrObserver, error, complete);
    safeSubscriber.syncErrorThrowable = true;

    _this.add(safeSubscriber);

    _this.safeSubscriber = safeSubscriber;
    return _this;
  }

  (0, _createClass2.default)(DoSubscriber, [{
    key: "_next",
    value: function _next(value) {
      var safeSubscriber = this.safeSubscriber;
      safeSubscriber.next(value);

      if (safeSubscriber.syncErrorThrown) {
        this.destination.error(safeSubscriber.syncErrorValue);
      } else {
        this.destination.next(value);
      }
    }
  }, {
    key: "_error",
    value: function _error(err) {
      var safeSubscriber = this.safeSubscriber;
      safeSubscriber.error(err);

      if (safeSubscriber.syncErrorThrown) {
        this.destination.error(safeSubscriber.syncErrorValue);
      } else {
        this.destination.error(err);
      }
    }
  }, {
    key: "_complete",
    value: function _complete() {
      var safeSubscriber = this.safeSubscriber;
      safeSubscriber.complete();

      if (safeSubscriber.syncErrorThrown) {
        this.destination.error(safeSubscriber.syncErrorValue);
      } else {
        this.destination.complete();
      }
    }
  }]);
  return DoSubscriber;
}(_Subscriber2.Subscriber);